module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "users-invite"
    }
  }, [_c('h1', [_vm._v("Convidar Usuário")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-mail ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    key: "email",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1)])]), (_vm.current_user.isAdmin()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('company_id')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "company_id"
    }
  }, [_vm._v("Empresa")]), _c('v-autocomplete', {
    attrs: {
      "id": "id",
      "auto-select-one-item": false,
      "items": _vm.company_options,
      "input-attrs": _vm.attrs
    },
    on: {
      "change": _vm.searchCompanies,
      "item-selected": _vm.selectedCompany
    },
    model: {
      value: (_vm.company_name),
      callback: function($$v) {
        _vm.company_name = $$v
      },
      expression: "company_name"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('company_id')),
      expression: "errors.has('company_id')"
    }],
    key: "company_id",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('company_id')))])])], 1)])]) : _vm._e(), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('role')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Função")]), _c('br'), (_vm.roleHaveSeats("manager")) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "role_manager",
      "type": "radio",
      "value": "manager",
      "name": "role"
    },
    domProps: {
      "checked": _vm._q(_vm.role, "manager")
    },
    on: {
      "change": function($event) {
        _vm.role = "manager"
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "id": "manager-role",
      "for": "role_manager"
    }
  }, [_vm._v("Gerente de contas")])]) : _vm._e(), (_vm.roleHaveSeats("sdr")) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }],
    attrs: {
      "id": "role_sdr",
      "type": "radio",
      "value": "sdr",
      "name": "role"
    },
    domProps: {
      "checked": _vm._q(_vm.role, "sdr")
    },
    on: {
      "change": function($event) {
        _vm.role = "sdr"
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "id": "seller-role",
      "for": "role_sdr"
    }
  }, [_vm._v("SDR")])]) : _vm._e(), (_vm.roleHaveSeats("seller")) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }],
    attrs: {
      "id": "role_seller",
      "type": "radio",
      "value": "seller",
      "name": "role"
    },
    domProps: {
      "checked": _vm._q(_vm.role, "seller")
    },
    on: {
      "change": function($event) {
        _vm.role = "seller"
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "id": "seller-role",
      "for": "role_seller"
    }
  }, [_vm._v("Executivo de vendas")])]) : _vm._e(), (_vm.roleHaveSeats("monitoring_manager")) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role),
      expression: "role"
    }],
    attrs: {
      "id": "role_monitoring_manager",
      "type": "radio",
      "value": "monitoring_manager",
      "name": "role"
    },
    domProps: {
      "checked": _vm._q(_vm.role, "monitoring_manager")
    },
    on: {
      "change": function($event) {
        _vm.role = "monitoring_manager"
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "id": "seller-role",
      "for": "role_monitoring_manager"
    }
  }, [_vm._v("Gerente de acompanhamento")])]) : _vm._e(), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('role')),
      expression: "errors.has('role')"
    }],
    key: "role",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('role')))])]), _c('div', {
    staticClass: "wrapper-buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "to": "/configuracoes/usuarios"
    }
  }, [_vm._v("Cancelar")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "submit"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Convidar Usuário")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4653c047!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/invitation_form.vue
// module id = 1092
// module chunks = 1